import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { SLIDE_SCHEMA } from '../../_builder-constants'
import { schema as baseHero } from '../hero/hero.schema'

/** A slide as the Neon Cinema hero reads it: the stored slide fields plus a badge and the spotlight colour. */
const NC_SLIDE_SCHEMA: FieldSchema[] = [
  ...SLIDE_SCHEMA,
  { key: 'badge', label: 'Badge', type: 'string', placeholder: 'New', help: 'Small label above the title.' },
  { key: 'glow', label: 'Spotlight colour', type: 'color', help: 'The light behind this slide; empty uses the theme colours in turn.' },
]

/** Neon Cinema hero: the base hero (stored keys and variant unchanged) with slide badges and spotlight colours. */
export const schema: ComponentSchema = {
  ...baseHero,
  variants: (baseHero.variants ?? []).map(variant => ({
    ...variant,
    fields: (variant.fields ?? []).map(field => (field.key === 'slides' ? { ...field, itemSchema: NC_SLIDE_SCHEMA } : field)),
  })),
}
